import { Eye } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface ExcludedToggleProps {
  showExcluded: boolean;
  onToggle: (value: boolean) => void;
}

export function ExcludedToggle({
  showExcluded,
  onToggle,
}: ExcludedToggleProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onToggle(!showExcluded)}
            className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
              showExcluded ? 'opacity-100' : 'opacity-30'
            }`}
            aria-label="Toggle Excluded Parts"
          >
            <Eye className="h-4 w-4 text-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="flex items-center gap-2 border-border bg-background text-foreground"
        >
          <span>
            {showExcluded ? 'Hide Excluded Parts' : 'Show Excluded Parts'}
          </span>
          <kbd className="rounded border border-border bg-muted px-1 font-mono text-xs text-muted-foreground">
            E
          </kbd>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
